<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header">
        <div class="row content-add-btn">
          <div class="col-4" v-if="isCreate()">
            <div class="text-left">
              <button
                class="btn btn-secondary custom-shadow-btn"
                passive
                @click="openModal('create')"
              >
                <em class="fa fa-plus"></em>
                Agregar Comercializadora
              </button>
            </div>
          </div>
          <div class="col-12 text-center">
            <hr />
          </div>
          <el-dialog
            v-if="isShow()"
            :title="nameBusinessSelected"
            :visible.sync="modals.read"
            width="70%"
            top="2%"
          >
            <p>
              A continuación encontrarás toda la información asociada al
              registro seleccionado.
            </p>
            <div class="card" v-if="rowData">
              <div class="card-header custom-shadow-card-header">
                <strong>Comercializadora: {{ rowData.name }}</strong>
              </div>
              <div class="card-body" v-if="rowData">
                <table class="table">
                  <tbody>
                    <tr class="shadow-sm">
                      <td>
                        <h6 class="custom-margin-h6-table">
                          <strong>Finca(s) Asociada(s):</strong>
                        </h6>
                        <span v-for="farm in rowData.farm_names" :key="farm">
                          <el-tag type="info">{{ farm }}</el-tag>
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </el-dialog>

          <el-dialog :title="title" :visible.sync="modals.create">
            <form>
              <div class="row">
                <div class="col-12">
                  <fg-input
                    ref="marketer"
                    type="text"
                    label="Comercializadora *"
                    v-model="marketerForm.name"
                    name="Comercializadora"
                    v-validate="modelValidations.name"
                    :error="getError('Comercializadora')"
                    placeholder="Dispositivo de ..."
                  >
                  </fg-input>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="form-group has-label">
                    <label class="text-transform-none"
                      >Seleccionar una o varias fincas*</label
                    >
                    <br />
                    <el-select
                      @change="
                        selectAllFromSelect('marketerForm.farm_ids', farms)
                      "
                      collapse-tags
                      id="bussiness_systems"
                      clearable
                      multiple
                      class="select-primary custom-width-select bus-rels shadow-sm"
                      size="large"
                      v-model="marketerForm.farm_ids"
                      placeholder="Seleccionar..."
                      filterable
                    >
                      <el-option
                        v-for="option in farms"
                        class="select-primary selected-all"
                        :value="option.id"
                        :label="option.name"
                        :key="option.name"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
              </div>
            </form>
            <span slot="footer" class="dialog-footer">
              <button
                class="btn btn-danger custom-shadow-btn"
                @click="closeModal('create')"
              >
                Cancelar</button
              >&nbsp;
              <button
                class="btn custom-btn-success custom-shadow-btn"
                @click="validate"
              >
                Confirmar
              </button>
            </span>
          </el-dialog>
        </div>
        <div v-if="isIndex()">
          <div
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <el-select
              clearable
              @clear="pagination.perPage = 10"
              class="select-default mb-3 shadow-sm"
              style="width: 200px"
              v-model="pagination.perPage"
              placeholder="Por página"
              filterable
            >
              <el-option
                class="select-default"
                v-for="item in pagination.perPageOptions"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
            <el-input
              clearable
              class="mb-3 shadow-sm"
              style="width: 200px"
              placeholder="Buscar registros"
              v-model="searchQuery"
              aria-controls="datatables"
            />
          </div>
          <div class="col-sm-12">
            <el-table
              stripe
              :default-sort="{ prop: 'name', order: 'descending' }"
              style="width: 100%"
              :data="queriedData"
              border
            >
              <el-table-column type="index" width="65"></el-table-column>
              <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                :min-width="column.minWidth"
                :prop="column.prop"
                :label="column.label"
              ></el-table-column>
              <el-table-column
                v-if="isShow() || isUpdate() || isDelete()"
                :min-width="110"
                label="Operaciones"
                fixed="right"
              >
                <template slot-scope="props">
                  <div class="text-center">
                    <a
                      v-if="isShow()"
                      v-tooltip.top-center="'Ver'"
                      class="btn-info btn-simple btn-link custom-margin-actions"
                      @click="handleView(props.$index, props.row)"
                    >
                      <em class="fa fa-eye custom-size-fa-actions"></em>
                    </a>
                    <a
                      v-if="isUpdate()"
                      v-tooltip.top-center="'Editar'"
                      class="btn-warning btn-simple btn-link custom-margin-actions"
                      @click="handleEdit(props.$index, props.row)"
                    >
                      <em class="fa fa-edit custom-size-fa-actions"></em>
                    </a>
                    <a
                      v-if="isDelete()"
                      v-tooltip.top-center="'Borrar'"
                      class="btn-danger btn-simple btn-link custom-margin-actions"
                      @click="handleDelete(props.$index, props.row)"
                    >
                      <em class="fa fa-times custom-size-fa-actions"></em>
                    </a>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div v-else>
          <br />
          <h5 class="text-muted text-center">
            Usted no tiene permisos para indexar la información registrada en el
            sistema
          </h5>
        </div>
        <div
          slot="footer"
          class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
        >
          <div class>
            <p class="card-category">
              Mostrando {{ from + 1 }} a {{ to }} de {{ total }} entradas
            </p>
          </div>
          <l-pagination
            class="pagination-no-border"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="pagination.total"
            pageFirst="false"
            pageLast="false"
          ></l-pagination>
        </div>
      </card>
      <!-- <div class="row" style="padding-right: 13px; padding-left: 13px;">
        <div class="col-6" v-if="isPDF()">
          <div class="text-right">
            <button class="btn btn-danger custom-shadow-btn" @click="exportToPDF">
              <em class="fa fa-file-pdf-o"></em>
              Exportar a PDF
            </button>
          </div>
        </div>
        <div class="col-6" v-if="isExcel()">
          <div class="text-left">
            <button class="btn custom-btn-success custom-shadow-btn" @click="exportToExcel">
              <em class="fa fa-file-excel-o"></em>
              Exportar a Excel
            </button>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import { Pagination as LPagination } from 'src/components/index';
import SweetAlert from 'src/class/Alerts';
import marketerTable from './marketerTable';
import store from '@/store';
import Fuse from 'fuse.js';
import MixinPermissions from 'src/util/mixinPermissions';
import mixinMasters from 'src/util/mixinMasters';
import { Axios } from 'src/class/Axios.js';
import { MixinExport } from 'src/mixins/mixin-export';
import { MixinNotification } from 'src/mixins/mixin-notification.js';
import MixinMenu from 'src/util/mixinMenu';

export default {
  components: {
    LPagination,
  },

  data() {
    return {
      marketerForm: {
        name: null,
        farm_ids: [],
      },
      marketerFormEdit: {
        name: null,
      },
      pagination: marketerTable.table.pagination,
      tableColumns: marketerTable.table.tableColumns,
      modals: {
        create: false,
        read: false,
        delete: false,
      },
      farms: [],
      searchQuery: '',
      tableData: [],
      rowData: null,
      fuseSearch: null,
      nameBusinessSelected: 'Registro selecionado...',
      modelValidations: {
        name: {
          required: true,
        },
      },
    };
  },

  mixins: [
    MixinPermissions,
    mixinMasters,
    MixinExport,
    MixinNotification,
    MixinMenu,
  ],

  methods: {
    openModal(name) {
      if (name == 'create') {
        sessionStorage.removeItem('editForm');
        (this.title = 'Agregar Comercializadora'), this.$validator.reset();
        this.marketerForm.name = null;
        this.marketerForm.farm_ids = [];
      }
      this.modals[name] = true;
    },

    closeModal(name) {
      this.modals[name] = false;
    },

    handleView(index, row) {
      this.rowData = row;
      this.modals['read'] = true;
    },

    handleEdit(index, row) {
      sessionStorage.setItem('editForm', JSON.stringify(row));
      this.marketerForm = Object.assign({}, row);
      this.modals['create'] = true;
    },

    handleDelete(index, row) {
      this.marketerForm = row;
      SweetAlert.delete(this.marketerForm.name).then((result) => {
        if (result.value) this.deleteMarketer();
      });
    },

    validate() {
      return this.$validator.validateAll().then((isValid) => {
        if (this.marketerForm.farm_ids.length == 0) {
          let sel = document.getElementById('bussiness_systems');
          sel.focus();
          sel.classList.add('custom-has-error');
          store.dispatch('utils/removeHasError', sel);
          return false;
        }
        if (isValid) {
          if (this.isCreate() && !sessionStorage.getItem('editForm')) {
            this.createMarketer();
          } else if (this.isUpdate() && sessionStorage.getItem('editForm')) {
            this.updateMarketer();
          }
        }
      });
    },

    createMarketer() {
      this.showHideLoading(true);
      this.marketerForm.route = 'marketers';
      Axios.saveMaster(this.marketerForm)
        .then((response) => {
          this.tableData.push(response.data.data);
          this.closeModal('create');
          this.showNotification(
            `${response.data.message}`,
            'success',
            'nc-simple-add',
            'Creación exitosa...'
          );
          this.showHideLoading();
        })
        .catch((error) => {
          this.closeModal('create');
          this.showNotification(
            `${error.response.data.message}`,
            'danger',
            'nc-simple-add',
            'Alerta...'
          );
          this.showHideLoading();
        });
    },

    updateMarketer() {
      this.marketerForm.route = 'marketers';
      this.marketerForm.id = JSON.parse(sessionStorage.getItem('editForm')).id;
      Axios.updateMaster(this.marketerForm)
        .then((response) => {
          this.modifyTable(1, this.marketerForm.id, response);
          this.closeModal('create');
          this.showHideLoading();
          sessionStorage.removeItem('editForm');
        })
        .catch((error) => {
          this.closeModal('create');
          this.showNotification(
            `${error.response.data.message}`,
            'danger',
            'nc-simple-add',
            'Alerta...'
          );
          this.showHideLoading();
          sessionStorage.removeItem('editForm');
        });
    },

    deleteMarketer() {
      if (this.isDelete()) {
        this.marketerForm.route = 'marketers';
        Axios.destroyMaster(this.marketerForm)
          .then((response) =>
            this.modifyTable(2, this.marketerForm.id, response)
          )
          .catch((error) => this.showMessageErrors(error));
      } else {
        this.showMessageAccess();
      }
    },

    exportToPDF() {
      let data = {};
      data.route = 'businesses/pdf';
      data.name_file = `${i18n.t('common_words.companies')}.pdf`;
      this.PDF(data)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },

    exportToExcel() {
      let data = {};
      data.route = 'businesses/excel';
      data.name_file = `${i18n.t('common_words.companies')}.xslx`;
      this.Excel(data)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },
  },

  created() {
    if (this.isIndex()) {
      this.showHideLoading(true);
      Promise.all([
        Axios.getMasters('marketers'),
        Axios.getMasters('farms/farms/only'),
      ])
        .then((responses) => {
          this.tableData = responses[0].data.data;
          this.farms = this.concatAll(responses[1].data.data);
          // this.farms = responses[1].data.data;
          this.fuseSearch = new Fuse(this.tableData, {
            useExtendedSearch: true,
            threshold: 0.3,
            keys: this.tableColumns.map((prop) => {
              return prop.prop;
            }),
          });
          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    } else {
      this.showHideLoading();
    }
  },

  mounted() {
    this.selectedItemOnMenu('businesses');
  },

  beforeDestroy() {
    this.deselectedItemOnMenu('businesses');
  },
};
</script>

<style scoped></style>
